import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Routes allowed without an active subscription
const OPEN_PATHS = ["/subscribe", "/payment/success", "/payment/cancel", "/support"];

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;

  const active = user.subscription_active || user.role === "admin";
  if (!active && !OPEN_PATHS.includes(location.pathname)) {
    return <Navigate to="/subscribe" replace />;
  }
  return children;
}
